import { render, staticRenderFns } from "./CloudOrder.vue?vue&type=template&id=4657cecd&scoped=true&"
import script from "./CloudOrder.vue?vue&type=script&lang=js&"
export * from "./CloudOrder.vue?vue&type=script&lang=js&"
import style0 from "./CloudOrder.vue?vue&type=style&index=0&id=4657cecd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4657cecd",
  null
  
)

export default component.exports